import { Link } from "react-router-dom";
import { ROUTES } from "@/config/routes";
import { DashboardStatusStrip } from "@/features/dashboard/components/DashboardStatusStrip";
import { RecentExportsSection } from "@/features/dashboard/components/RecentExportsSection";
import { WelcomeCard } from "@/features/dashboard/components/WelcomeCard";
import { useDashboardStats } from "@/features/dashboard/hooks/useDashboardStats";
import { ImportantNoteCard } from "@/features/layout/components/ImportantNoteCard";
import { PageHeader } from "@/features/layout/components/PageHeader";

export function DashboardPage() {
  const { tiles, isLoading } = useDashboardStats();

  return (
    <div className="space-y-6">
      <PageHeader title="Dashboard" breadcrumbSuffix="Dashboard" />

      <ImportantNoteCard />

      <WelcomeCard />

      {!isLoading ? (
        <DashboardStatusStrip exportsInProgress={tiles.inProgress} />
      ) : null}

      <section className="panel overflow-hidden p-0">
        <div className="table-toolbar border-b border-[var(--border-soft)] px-4 py-3">
          <strong className="text-sm">Recent exports</strong>
          <Link to={ROUTES.exports} className="link-quiet text-sm">
            View all →
          </Link>
        </div>
        <RecentExportsSection embedded />
      </section>
    </div>
  );
}
